import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import axios from "axios";
import Spinner from "react-spinner-material";
import ENV from "../../../../environment";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #ccc',
    boxShadow: 24,
    p: 4,
};

function HistoryModal({ open, onClose, hotelId, categoryId, abbreviation }) {
    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            fetchHistory();
        }
    }, [open]);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${ENV.URL}/api/hdp/tts/adm/hotel/${hotelId}/category/${categoryId}/price/history`, {
                headers: {
                    Authorization: sessionStorage.getItem("token"),
                    "client-id": ENV.CLIENTID,
                    "client-secret": ENV.SECRET,
                },
            });
            setHistoryData(res.data.data || []);
        } catch (err) {
            console.error("Error fetching history", err);
        }
        setLoading(false);
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>
                    Price History for: {abbreviation}
                </Typography>
                {loading ? (
                    <Spinner radius={80} color={"#1976d2"} stroke={8} visible={true} />
                ) : historyData.length > 0 ? (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Old Price</TableCell>
                                <TableCell>New Price</TableCell>
                                <TableCell>Changed By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {historyData.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{new Date(item.date).toLocaleDateString()}</TableCell>
                                    <TableCell>{item.oldPrice}</TableCell>
                                    <TableCell>{item.newPrice}</TableCell>
                                    <TableCell>{item.changedBy}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <Typography>No history available</Typography>
                )}
            </Box>
        </Modal>
    );
}

export default HistoryModal;
